import React from 'react';

const IconPlaySolid: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="currentColor" {...props}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
      d="M21.5803792,13.788641 L5.64442719,21.756617 C4.6564702,22.2505955 3.45512412,21.8501468 2.96114562,20.8621898 C2.82229018,20.5844789 2.75,20.2782528 2.75,19.9677626 L2.75,4.03181059 C2.75,2.92724109 3.6454305,2.03181059 4.75,2.03181059 C5.06049019,2.03181059 5.36671632,2.10410077 5.64442719,2.24295621 L21.5803792,10.2109322 C22.5683362,10.7049107 22.9687849,11.9062568 22.4748064,12.8942138 C22.281279,13.2812686 21.967434,13.5951136 21.5803792,13.788641 Z"
    />
  </svg>
);

export default IconPlaySolid;
